<template>
  <StudioMultiSelect
    v-model="sentimentSelected"
    :searchable="true"
    :items="selectItems"
    :label="label"
    :placeholder="placeholder"
    :clearable="clearable"
    @clearClick="$emit('clearInfo', label)"
  >
    <template v-slot:selection="{index}">
      <span
        v-if="index === 0"
        class="grey--text caption"
      >
        {{ sentimentSelected.length }} {{ filterMessage(sentimentSelected) }}
      </span>
    </template>
  </StudioMultiSelect>
</template>

<script>
import sentimentModel from '@/mixins/sentiment-model';
import StudioMultiSelect from '@/components/filter/models/StudioMultiSelect';
import filtersModel from '@/mixins/filters-model';

export default {
  name: 'PolarityFilter',
  components: {
    StudioMultiSelect,
  },
  mixins: [
    sentimentModel,
    filtersModel,
  ],
  props: {
    value: {
      type: Object,
      default: () => {
      },
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    label() {
      return this.$t('components.filters.PolarityFilter.label');
    },
    placeholder() {
      return this.$t('components.filters.PolarityFilter.placeholder');
    },
    sentimentSelected: {
      get() {
        if (this.value && this.value.value) {
          return this.value.value;
        }

        return [];
      },
      set(newValue) {
        let newSentiments = newValue;

        if (!newValue || newValue.length === 0) {
          return this.$emit('input', undefined);
        }

        if (newValue && newValue.length && typeof (newValue[0]) === 'object') {
          newSentiments = newValue.map(v => v && v.value);
        }

        this.$emit('input', {
          value: newSentiments,
        });
      },
    },
    selectItems() {
      const sentiment = this.sentiment.map(sentiment => {
        const sentimentObj = this.getSentimentObj(sentiment);
        return {
          text: sentimentObj.name,
          value: sentimentObj.value,
        };
      });

      return [
        {
          text: this.$t('components.filters.PolarityFilter.notClassified'),
          value: -2,
        },
        ...sentiment,
      ];
    },
  },
};

</script>

<style scoped lang="scss">
  .v-select__selection.v-select__selection--comma {
    line-height: 120%;
  }
</style>
